var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2 pcksgreport", attrs: { fluid: "" } },
    [
      _c("RangePicker", {
        attrs: { range: this.getCurrentMonth() },
        on: { reloadData: _vm.loadData }
      }),
      _vm._v(" "),
      _c("v-subheader", [_vm._v("Package Sales by Source")]),
      _vm._v(" "),
      _c(
        "v-data-table",
        {
          attrs: {
            headers: _vm.headers,
            items: _vm.totalsbysource,
            "items-per-page": 30,
            "group-by": "agentName"
          },
          scopedSlots: _vm._u([
            {
              key: "item.agentName",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(
                    "\n                      " +
                      _vm._s(item.agentName) +
                      " 3\n                  "
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("template", { slot: "body.append" }, [
            _c(
              "tr",
              { staticClass: "pink--text" },
              _vm._l(_vm.headers, function(item, index) {
                return _c("th", { staticClass: "title" }, [
                  _vm._v(
                    "\n" +
                      _vm._s(index > 0 && index % 2 == 0 ? "$" : "") +
                      _vm._s(
                        index > 0
                          ? _vm.sum(_vm.totalsbysource, item.value)
                          : " "
                      ) +
                      "\n                          "
                  )
                ])
              }),
              0
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }